export const environment = {
  production: true,
  apidlocal: 'http://localhost:4370/api/',
  api: 'https://api-miviaje.denario.com.co/api/',
  apiWaderlust: 'https://wanderlus-adminpanel-prod-aad2g6dggfgsesey.eastus2-01.azurewebsites.net/api',
  token: 'oesZZmHNycbhBXjBoVQi9YXi5M3hMdXm6gEHUWHE154e8f72',
  amadeusApi: 'https://amadeus-api-php-prod-gfayc8b3cbhsdbgf.eastus2-01.azurewebsites.net',
};
